import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "dialog"];

  submit(event) {
    const dialog = document.querySelector("#portal-invite-modal");

    if (dialog) {
      event.preventDefault();

      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        console.warn("Your browser doesn't support <dialog>. Consider a polyfill.");
        dialog.classList.remove("hidden");
      }

      dialog.addEventListener("close", () => {
        if (dialog.returnValue === "confirm") {
          this.formTarget.submit();
        }
      });
    }
  }

  confirmInvite(event) {
    event.preventDefault();

    const fileNumberValue = document.getElementById("modal-file-number")?.value;
    if (fileNumberValue) {
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "file_number";
      hiddenInput.value = fileNumberValue;

      this.formTarget.appendChild(hiddenInput);
    }

    const dialog = this.hasDialogTarget ? this.dialogTarget : null;
    if (dialog) {
      dialog.close();
    }

    this.formTarget.requestSubmit();
  }
}
